module.exports = __webpack_public_path__ + "img/MAX.6c2b9530.svg";